import { render, staticRenderFns } from "./resupply-products-new-v2.modal.vue?vue&type=template&id=4a4a12c4&scoped=true"
import script from "./resupply-products-new-v2.modal.vue?vue&type=script&lang=js"
export * from "./resupply-products-new-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./resupply-products-new-v2.modal.vue?vue&type=style&index=0&id=4a4a12c4&prod&lang=scss&scoped=true"
import style1 from "./resupply-products-new-v2.modal.vue?vue&type=style&index=1&id=4a4a12c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4a12c4",
  null
  
)

export default component.exports